// Cuello Relax — scripts propios (vanilla, sin librerías)
(function () {
  'use strict';

  // Habilita el estado :active en iOS/Safari al tocar tarjetas (sin esto, :active no reacciona al tacto)
  document.addEventListener('touchstart', function () {}, true);

  var CR_CONSENT_KEY = 'cr_cookie_consent';

  function crObtenerConsentimiento() {
    try { return window.localStorage.getItem(CR_CONSENT_KEY); } catch (e) { return null; }
  }

  function crGuardarConsentimiento(valor) {
    try { window.localStorage.setItem(CR_CONSENT_KEY, valor); } catch (e) {}
    window.crConsentimientoCookies = valor;
    document.dispatchEvent(new CustomEvent('cr:consentimiento', { detail: { valor: valor } }));
  }

  function initCookies() {
    var banner = document.getElementById('cr-cookies');
    if (!banner) return;

    var guardado = crObtenerConsentimiento();
    window.crConsentimientoCookies = guardado;

    if (!guardado) {
      banner.hidden = false;
    }

    banner.querySelectorAll('[data-cr-cookies]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var valor = boton.getAttribute('data-cr-cookies') === 'aceptar' ? 'todas' : 'necesarias';
        crGuardarConsentimiento(valor);
        banner.hidden = true;
      });
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('.cr-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cr-visible'); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('cr-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initTilt() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;
    var tarjetas = document.querySelectorAll('.cr-tilt');
    tarjetas.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'perspective(800px) rotateY(' + (x * 8) + 'deg) rotateX(' + (y * -8) + 'deg) translateY(-6px)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  function initContadores() {
    var els = document.querySelectorAll('[data-cuenta-hasta]');
    if (!els.length) return;
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function animar(el) {
      var hasta = parseFloat(el.getAttribute('data-cuenta-hasta'));
      var decimales = el.getAttribute('data-cuenta-decimales') ? parseInt(el.getAttribute('data-cuenta-decimales'), 10) : 0;
      var sufijo = el.getAttribute('data-cuenta-sufijo') || '';
      if (reducido || !('IntersectionObserver' in window)) {
        el.textContent = hasta.toFixed(decimales) + sufijo;
        return;
      }
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var facilitado = 1 - Math.pow(1 - progreso, 3);
        el.textContent = (hasta * facilitado).toFixed(decimales) + sufijo;
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animar(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { obs.observe(el); });
  }

  function initCompraDirecta() {
    var forms = document.querySelectorAll('.cr-producto-form');
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var boton = form.querySelector('.cr-btn-comprar-ahora');
        if (boton && boton.disabled) return;

        var textoOriginal = boton ? boton.textContent.trim() : '';
        if (boton) {
          boton.disabled = true;
          boton.textContent = boton.getAttribute('data-texto-procesando') || textoOriginal;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function () {
            if (boton) {
              boton.disabled = false;
              boton.textContent = textoOriginal;
            }
            form.submit();
          });
      });
    });
  }

  function initFaq() {
    var items = document.querySelectorAll('.cr-faq-item');
    if (!items.length) return;
    items.forEach(function (item) {
      var pregunta = item.querySelector('.cr-faq-pregunta');
      if (!pregunta) return;
      pregunta.addEventListener('click', function () {
        var abierta = item.classList.contains('cr-faq-abierta');
        items.forEach(function (i) { i.classList.remove('cr-faq-abierta'); });
        if (!abierta) item.classList.add('cr-faq-abierta');
      });
    });
  }

  function initGaleriaProducto() {
    var galerias = document.querySelectorAll('.cr-producto-galeria');
    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('.cr-galeria-principal img');
      var minis = galeria.querySelectorAll('.cr-galeria-mini');
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-full');
          var alt = mini.getAttribute('data-alt') || '';
          if (!src) return;
          principal.setAttribute('src', src);
          principal.setAttribute('alt', alt);
          minis.forEach(function (m) { m.classList.remove('cr-galeria-mini-activa'); });
          mini.classList.add('cr-galeria-mini-activa');
        });
      });
    });
  }

  function initVariantes() {
    var forms = document.querySelectorAll('.cr-producto-form');
    forms.forEach(function (form) {
      var dataEl = form.querySelector('.cr-variantes-json');
      var selects = form.querySelectorAll('.cr-opcion-select');
      if (!dataEl || !selects.length) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = form.querySelector('input[name="id"]');
      var precioEl = form.querySelector('.cr-precio-actual');
      var precioComparado = form.querySelector('.cr-precio-comparado');
      var botonAgregar = form.querySelector('.cr-btn-agregar');

      function opcionesSeleccionadas() {
        var vals = [];
        selects.forEach(function (s) { vals.push(s.value); });
        return vals;
      }

      function formatearDinero(centavos) {
        return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
        });
      }

      function actualizar() {
        var seleccion = opcionesSeleccionadas();
        var variante = variantes.find(function (v) {
          return v.options.every(function (opt, idx) { return opt === seleccion[idx]; });
        });
        if (!variante) return;
        idInput.value = variante.id;
        if (precioEl) precioEl.textContent = formatearDinero(variante.price);
        if (precioComparado) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioComparado.textContent = formatearDinero(variante.compare_at_price);
            precioComparado.style.display = '';
          } else {
            precioComparado.style.display = 'none';
          }
        }
        if (botonAgregar) {
          if (variante.available) {
            botonAgregar.disabled = false;
            botonAgregar.textContent = botonAgregar.getAttribute('data-texto-disponible');
          } else {
            botonAgregar.disabled = true;
            botonAgregar.textContent = botonAgregar.getAttribute('data-texto-agotado');
          }
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    });
  }

  function initAntesDespues() {
    var figuras = document.querySelectorAll('[data-cr-antes-despues]');
    figuras.forEach(function (figura) {
      if (figura.getAttribute('data-cr-ad-listo')) return;
      figura.setAttribute('data-cr-ad-listo', '1');

      var manija = figura.querySelector('.cr-ad-manija');
      var despues = figura.querySelector('.cr-ad-despues');
      var arrastrando = false;

      function fijarPosicion(pct) {
        pct = Math.max(4, Math.min(96, pct));
        figura.style.setProperty('--cr-ad-pos', pct + '%');
      }

      function posicionDesdeEvento(e) {
        var rect = figura.getBoundingClientRect();
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        var x = clientX - rect.left;
        return (x / rect.width) * 100;
      }

      figura.addEventListener('pointerdown', function (e) {
        arrastrando = true;
        if (figura.setPointerCapture) {
          try { figura.setPointerCapture(e.pointerId); } catch (err) {}
        }
        fijarPosicion(posicionDesdeEvento(e));
      });
      figura.addEventListener('pointermove', function (e) {
        if (arrastrando) fijarPosicion(posicionDesdeEvento(e));
      });
      figura.addEventListener('pointerup', function () { arrastrando = false; });
      figura.addEventListener('pointercancel', function () { arrastrando = false; });

      var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducido || !('IntersectionObserver' in window)) return;

      var barrido = false;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !barrido) {
            barrido = true;
            fijarPosicion(28);
            setTimeout(function () {
              if (manija) manija.style.transition = 'left 1.1s var(--cr-ease)';
              if (despues) despues.style.transition = 'clip-path 1.1s var(--cr-ease)';
              setTimeout(function () { fijarPosicion(72); }, 60);
              setTimeout(function () {
                fijarPosicion(50);
                setTimeout(function () {
                  if (manija) manija.style.transition = '';
                  if (despues) despues.style.transition = '';
                }, 1150);
              }, 1300);
            }, 50);
            obs.unobserve(figura);
          }
        });
      }, { threshold: 0.5 });
      obs.observe(figura);
    });
  }

  function crInicializarTodo() {
    initReveal();
    initTilt();
    initContadores();
    initFaq();
    initGaleriaProducto();
    initVariantes();
    initCompraDirecta();
    initAntesDespues();
  }

  document.addEventListener('DOMContentLoaded', function () {
    crInicializarTodo();
    initCookies();
  });

  // El editor de temas de Shopify vuelve a renderizar una sección por AJAX
  // cada vez que se edita algo en el panel lateral. Los elementos nuevos
  // (con clases como .cr-reveal, que empiezan invisibles hasta que el
  // IntersectionObserver los detecta) no existían cuando corrió DOMContentLoaded,
  // así que sin esto se quedan invisibles al editar.
  document.addEventListener('shopify:section:load', crInicializarTodo);
})();
